import { useModalActions } from "@store/modal/modal";
import { useExpensePlanBankAccountsQuery } from "@services/budget/queries";
import { AddExpensePlanModal } from "./AddExpensePlanModal";

export const useAddExpensePlanModal = () => {
  const { create } = useModalActions();
  const { data: expensePlanBankAccounts } = useExpensePlanBankAccountsQuery();

  const openAddExpensePlanModal = () => {
    if (!expensePlanBankAccounts) {
      return;
    }

    create((modalProps) => (
      <AddExpensePlanModal
        expensePlanBankAccounts={expensePlanBankAccounts}
        {...modalProps}
      />
    ));
  };

  return { openAddExpensePlanModal };
};
